module.exports = __webpack_public_path__ + "img/river-of-calm.8449045c.png";